<template>
  <form class="queue-account" @submit.prevent="handleSubmit">
    <QueueInput v-model="name" label="Nome" />
    <QueueInput v-model="email" label="E-mail" type="email" />
    <QueueInput v-model="stationName" label="Estação" />
    <QueueButton label="Criar conta" type="submit" />
    <p v-if="error" class="queue-account__error">{{ error }}</p>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import QueueInput from '../inputs/QueueInput.vue'
import QueueButton from '../buttons/QueueButton.vue'

export default {
  name: 'QueueAccount',
  components: {
    QueueInput,
    QueueButton
  },
  data () {
    return {
      name: '',
      email: '',
      stationName: '',
      error: ''
    }
  },
  methods: {
    ...mapActions(['createAccount', 'createStation']),
    async handleSubmit () {
      this.error = ''

      if (!this.name || !this.email || !this.stationName) {
        this.error = 'Preencha nome, e-mail e estação'
        return
      }

      try {
        const account = await this.createAccount({ name: this.name, email: this.email })
        await this.createStation({ accountId: account.id, name: this.stationName })
        this.$router.push(`/${account.name}/work`)
      } catch (err) {
        this.error = err.message
      }
    }
  }
}
</script>

<style scoped>
.queue-account {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 100vh;
}

.queue-account__error {
  margin: 0;
  color: #dc2626;
  font-weight: bold;
}
</style>
